import React from 'react'

import { Carousel } from '@peracto/peracto-blocks-tailwind'

import Form from './Form/CarouselForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = Carousel

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/carousel',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            slideDuration: 5000,
            transition: 'slide',
            transitionDuration: 1000,
            autoplay: false,
            showIndicators: false,
            images: [],
            selectedImageIndex: 0,
        }),
    }
}

export default createPlugin
